module.exports = __webpack_public_path__ + "img/equipments.e8082920.png";